import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {AppHttpClient} from '@common/core/http/app-http-client.service';
import {BiolinkEditorService} from '../../biolink-editor.service';

export interface CrupdateWidgetDialogData {
    biolinkId: number;
    widgetId?: number;
    config?: {url: string; embedCode: string};
}

@Component({
    selector: 'soundcloud-widget-modal',
    templateUrl: './soundcloud-widget-modal.component.html',
    styleUrls: ['./soundcloud-widget-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SoundcloudWidgetModalComponent {
    static type: 'soundcloudEmbed';
    errors$ = new BehaviorSubject<{url?: string}>({});
    form = new FormGroup({
        url: new FormControl(''),
    });

    constructor(
        private dialogRef: MatDialogRef<SoundcloudWidgetModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: CrupdateWidgetDialogData,
        private http: AppHttpClient,
        public editor: BiolinkEditorService
    ) {
        if (data.config) {
            this.form.patchValue(data.config);
        }
    }

    createOrUpdate() {
        this.editor.loading$.next(true);
        const encodedUrl = encodeURIComponent(this.form.value.url);
        this.http
            .get('https://soundcloud.com/oembed?format=json&url=' + encodedUrl)
            .subscribe(
                response => {
                    let embedCode = (response as any).html;
                    if (!embedCode) {
                        this.editor.loading$.next(false);
                        return this.errors$.next({
                            url: 'This is not a valid soundcloud url.',
                        });
                    }
                    embedCode = embedCode.replace(
                        'height="400"',
                        'height="180"'
                    );

                    this.editor
                        .crupdateWidget(
                            this.data.widgetId,
                            SoundcloudWidgetModalComponent.type,
                            {
                                embedCode,
                                url: this.form.value.url,
                            }
                        )
                        .subscribe(r => {
                            this.dialogRef.close(r.widget);
                        });
                },
                () => {
                    this.editor.loading$.next(false);
                    this.errors$.next({
                        url: 'Could not get soundcloud embed code, try again later.',
                    });
                }
            );
    }

    close() {
        this.dialogRef.close();
    }
}
